import * as React from "react";

export const BinSVG = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={18} viewBox="0 0 14 18" {...props}>
        <defs>
            <style>{".prefix__a{fill:#b42025;fill-rule:evenodd}"}</style>
        </defs>
        <path
            className="prefix__a"
            d="M13.282 4.078l-.64 11.744A2.135 2.135 0 0110.67 18H3.33a2.135 2.135 0 01-1.971-2.178L.719 4.078zM3.698 6.371a.614.614 0 01.652.571l.439 8.131a.621.621 0 01-1.24.063l-.44-8.131a.612.612 0 01.588-.634zm6.1 9.336a.617.617 0 00.652-.571l.439-8.131a.621.621 0 00-1.24-.063l-.439 8.131a.614.614 0 00.59.634zm-2.8-9.342a.614.614 0 01.621.6v8.142a.621.621 0 01-1.242 0V6.968a.614.614 0 01.624-.603zM.86 1.9h2.554l.62-1.2A1.3 1.3 0 015.2 0h3.6a1.3 1.3 0 011.166.7l.62 1.2h2.554a.851.851 0 01.86.838v.838H0v-.838A.851.851 0 01.86 1.9zm3.629 0h5.022l-.4-.778A.324.324 0 008.8.938H5.2a.323.323 0 00-.308.184z"
        />
    </svg>
);
